// Map loader utility for lazy loading Leaflet and map dependencies
let mapsLoaded = false;

export async function loadMaps() {
    if (mapsLoaded) {
        return {
            L: window.L,
            cyanLeaflet: window.cyanLeaflet
        };
    }

    try {
        // Dynamic import of map module that includes all dependencies
        await import('./maps.js');
        
        mapsLoaded = true;
        return {
            L: window.L,
            cyanLeaflet: window.cyanLeaflet
        };
    } catch (error) {
        console.error('Failed to load map dependencies:', error);
        throw error;
    }
}

// Global function for Blade templates
window.loadMaps = loadMaps;

export default loadMaps;